import { List, Grid } from 'antd';
import { useTranslation } from 'react-i18next';
import { useGetLifeDoc } from 'all-in-one-shared-api';
import { useKeycloakReady } from 'hooks';
import { useEffect } from 'react';
import { isLocaleEnglish } from 'utils';
import PdfFileIcon from 'assets/images/PDFfileicon.svg';
import ChevronRight from 'assets/images/home/chevron-right.svg';

function TopList() {
  const { t, i18n } = useTranslation();
  const { token } = useKeycloakReady();
  const { useBreakpoint } = Grid;
  const { xl } = useBreakpoint();
  const {
    shouldFetch: GetLifeDocFetch,
    data: GetLifeDocFetchData,
    isLoading: GetLifeDocFetchDataisLoading,
  } = useGetLifeDoc('useGetLifeDoc', token || '');
  useEffect(() => {
    GetLifeDocFetch(true);
  }, [GetLifeDocFetch]);
  return (
    <List
      style={{ background: '#fff', width: '680px', height: '387' }}
      size="large"
      className={`List ${!xl ? 'to-center' : ''}`}
      header={
        <div>
          <span className="headertittle">{t('life.MakeRequest.Dstittle')}</span>
        </div>
      }
      bordered
      loading={GetLifeDocFetchDataisLoading}
      dataSource={GetLifeDocFetchData?.serviceForms}
      renderItem={(item) => (
        <List.Item style={{ display: 'flex', flexWrap: 'nowrap' }}>
          <a
            href={isLocaleEnglish(i18n.language) ? item.docUrlEn || '' : item.docUrlTc || ''}
            target="_blank"
            rel="noreferrer"
            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}
          >
            <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '90%' }}>
              <img src={PdfFileIcon} style={{ margin: '0  10px 5px 0', width: '24px', height: '24px' }} />
              <span style={{ fontFamily: 'Roboto400', fontSize: '20px', color: '#20252B' }}>
                {isLocaleEnglish(i18n.language) ? item.docDescEn || '' : item.docDescTc || ''}
              </span>
            </div>
            <img src={ChevronRight} style={{ margin: '0  10px 0 0', width: '8px', height: '14px' }} />
          </a>
        </List.Item>
      )}
    />
  );
}
export default TopList;
